/**
 * OVERRIDE Logo.jsx
 */

import Logo from '../../../../components/Logo/Logo';

export default Logo;